// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAIlowQ5DIZ-qHdfmBKE65JP3tJUK1p_14",
    authDomain: "laer-39ee6.firebaseapp.com",
    databaseURL: "https://laer-39ee6.firebaseio.com",
    projectId: "laer-39ee6",
    storageBucket: "laer-39ee6.appspot.com",
    messagingSenderId: "934412461250",
    appId: "1:934412461250:web:2ce3b9f5b2e90fc48d475b",
    measurementId: "G-NJZX52FB4L"
  },
  skyway: '5b4db691-1d68-4c1e-8a61-3629e7d17809',
  payjp: 'sk_test_9506a57258f076d6d9392ceb',
  payjp_public: "pk_test_6f49cd7ae8771cebb875e1cc",
  twitter_api: 'XN6pxcA2XvREvzoeR7SnttdZy',
  twitter_secret: '1HVhqW9TJGKgX4gDN25GO4oT5nEQtTliR5omf5fbVxqSPwsjeh',
  function_url: 'https://asia-northeast1-laer-39ee6.cloudfunctions.net/',
  site_url: "https://laer-39ee6.firebaseapp.com",
  projectID: "laer-39ee6",
  crypto_key: "AErdKQfqN3L4TY7YktgxBw==",
  env: "development"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
